export const humanize = (string: string) => {
  // Replace underscores with spaces
  let result = string?.replace(/_/g, " ");

  // Capitalize the first letter of each word
  result = result?.replace(/\b\w/g, function (match) {
    return match?.toUpperCase();
  });

  return result;
};

export const localizeDate = (date: number): string => {
  return new Date(date)?.toLocaleDateString(); // dd/mm/yyyy
};

export const localizeDateTime = (date: number): string => {
  return new Date(date)?.toLocaleString(); // dd/mm/yyyy hh:mm:ss
};

export const requiredDateTimeFormat = (date: number): string => {
  const [datePart, timePart] = localizeDateTime(date).split(", ");
  const [day, month, year] = datePart.split("/");
  const [hours, minutes] = timePart.split(":");
  return `${year}-${month}-${day}T${hours}:${minutes}`;
};

export const customerAddress = (data: any): string => {
  const { address_line1, address_line2, customer_city, pincode, state } = data;

  const addressParts = [address_line1, address_line2, customer_city, pincode, state?.name];

  // Filter out undefined or empty values
  const filteredAddressParts = addressParts.filter((part) => part);

  // Join the filtered parts with a comma and space
  return filteredAddressParts.join(", ");
};

export const formatToUTCDateString = (date: number): string => {
  const [day, month, year] = localizeDate(date).split("/");
  // Reformat the date string
  return `${year}-${month}-${day}`;
};

export const isUserHasRoleTypes = (user: any, roleTypes: Array<string>): boolean => {
  return user?.roles?.some((role: any) => roleTypes.includes(role.role_type));
};

export const getStatusText = (assignment: any): string => {
  if (!assignment || !assignment.status) return "-";
  if (assignment.approved_at && assignment.status === "in_progress") {
    return `${humanize(assignment.status)} - Approved`;
  }
  return humanize(assignment.status);
};

export const idsToArray = (ids: any) => {
  return ids?.split(",").map((ele: any) => parseInt(ele));
};

export const commaSeparatedToArray = (value: any) => {
  return value?.split(",").map((ele: any) => (ele === "null" ? null : ele)) || [];
};

const getQuery = (): URLSearchParams => {
  if (typeof window === "undefined") {
    return new URLSearchParams();
  }

  return new URLSearchParams(window.location.search);
};

export const getQuerySearchParams = (): Record<string, any> => {
  const query = getQuery();

  return {
    ecb_code: query.get("ecb_code"),
    brand_id: idsToArray(query.get("brand_id")),
    customer_name: query.get("customer_name"),
    assigned_city_manager_id: idsToArray(query.get("assigned_city_manager_id")),
    contact_number: query.get("contact_number"),
    status: commaSeparatedToArray(query.get("status")),
    zone_id: idsToArray(query.get("zone_id")),
    city_id: idsToArray(query.get("city_id")),
    agent_id: idsToArray(query.get("agent_id")),
    start_date: query.get("start_date"),
    next_follow_up_start: query.get("next_follow_up_start"),
    next_follow_up_end: query.get("next_follow_up_end"),
    partner_id: idsToArray(query.get("partner_id")),
    brand_booking_code: query.get("brand_booking_code"),
    brand_booking_status: commaSeparatedToArray(query.get("brand_booking_status")),
    end_date: query.get("end_date"),
    install_type: query.get("install_type"),
    is_first_contact: query.get("is_first_contact"),
    state_id: idsToArray(query.get("state_id")),
    start_approved_at: query.get("start_approved_at"),
    end_approved_at: query.get("end_approved_at"),
    page: query.get("page") || 1,
    page_size: query.get("page_size") || 20
  };
};

export const applyPaginationToQueryParams = (values: any) => {
  const params = new URLSearchParams();
  const querySearchParams = getQuerySearchParams();
  Object.entries(values).map((key) => {
    const fieldValue = querySearchParams[key[0]];
    if (Array.isArray(fieldValue)) {
      if (fieldValue.length > 0) {
        params.set(key[0], fieldValue.join(","));
      } else {
        params.delete(key[0]);
      }
    } else if (fieldValue !== undefined && fieldValue !== "" && fieldValue !== null) {
      params.set(key[0], fieldValue);
    } else {
      params.delete(key[0]);
    }
  });
  params.set("page", values.page);
  params.set("page_size", values.page_size);
  values.navigate(`?${params.toString()}`);
};
